import Vue from "vue";
import customComponents from "@/components"
import Vant from "vant";
import "vant/lib/index.css";
import utils from "@/utils";
import '@/plugin/mixin'
import '@/plugin/filters'
import option from "@/assets/js/option";
// 导入lodash，lodash用下划线接
import _ from 'lodash'
import {Lazyload} from 'vant';


Vue.prototype.$utils = utils;
Vue.prototype.$opt = option;
Vue.prototype.$_ = _;
Vue.use(Vant);
Vue.use(customComponents);

Vue.use(Lazyload, {
    lazyComponent: true,
});


